"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const styles = exports.styles = {
  wrapper: {
    display: "x78zum5",
    flexGrow: "x1iyjqo2",
    flexDirection: "xdt5ytf",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    paddingTop: "x1hx5lgg",
    paddingBottom: "xypa8z9",
    paddingLeft: "x1oqrxb4",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "xlwr664",
    textAlign: "x2b8uid",
    $$css: true
  },
  headline: {
    fontSize: "x12xc60p",
    fontWeight: "x1s688f",
    marginTop: "xdj266r",
    marginBottom: "xyi6m4r",
    color: "x10kmngs",
    $$css: true
  },
  subhead: {
    fontSize: "xngnso2",
    lineHeight: "x1dbl2gt",
    maxWidth: "x6ymgno",
    color: "xcdm7ny",
    marginBottom: "x1t84w78",
    $$css: true
  }
};